import { insurance } from '@axo/shared/data-access/types';

export const insuranceSourceTag: insurance.InsuranceSourceTag =
  'application-form-flow';
